declare namespace $ {

	type $mol_check__title_bog_vmap_app_code_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__hint_bog_vmap_app_code_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['hint'] >
	>
	type $mol_check__checked_bog_vmap_app_code_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_code['whole'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_status__status_bog_vmap_app_code_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_code['error'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_status__status_bog_vmap_app_code_5 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_code['note'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_list__rows_bog_vmap_app_code_6 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_code['typing_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_status__status_bog_vmap_app_code_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_code['typing_text'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $bog_vmap_app_code_deck__items_bog_vmap_app_code_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_code['source_tabs'] >
		,
		ReturnType< $bog_vmap_app_code_deck['items'] >
	>
	type $mol_textarea__title_bog_vmap_app_code_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['title'] >
	>
	type $mol_textarea__hint_bog_vmap_app_code_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__sidebar_showed_bog_vmap_app_code_11 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['sidebar_showed'] >
	>
	type $mol_textarea__enabled_bog_vmap_app_code_12 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_code['editable'] >
		,
		ReturnType< $mol_textarea['enabled'] >
	>
	type $mol_textarea__value_bog_vmap_app_code_13 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_code['tree_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__event_bog_vmap_app_code_14 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_vmap_app_code['tree_press'] > ): ReturnType< $bog_vmap_app_code['tree_press'] >,
		})  & ReturnType< $mol_textarea['event'] >
		,
		ReturnType< $mol_textarea['event'] >
	>
	type $mol_textarea__title_bog_vmap_app_code_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['title'] >
	>
	type $mol_textarea__hint_bog_vmap_app_code_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__sidebar_showed_bog_vmap_app_code_17 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['sidebar_showed'] >
	>
	type $mol_textarea__enabled_bog_vmap_app_code_18 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_code['editable'] >
		,
		ReturnType< $mol_textarea['enabled'] >
	>
	type $mol_textarea__value_bog_vmap_app_code_19 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_code['js_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__event_bog_vmap_app_code_20 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_vmap_app_code['js_press'] > ): ReturnType< $bog_vmap_app_code['js_press'] >,
		})  & ReturnType< $mol_textarea['event'] >
		,
		ReturnType< $mol_textarea['event'] >
	>
	type $mol_status__title_bog_vmap_app_code_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_status['title'] >
	>
	type $mol_status__status_bog_vmap_app_code_22 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_code['js_idle_note'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_textarea__title_bog_vmap_app_code_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['title'] >
	>
	type $mol_textarea__hint_bog_vmap_app_code_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__sidebar_showed_bog_vmap_app_code_25 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['sidebar_showed'] >
	>
	type $mol_textarea__enabled_bog_vmap_app_code_26 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_code['editable'] >
		,
		ReturnType< $mol_textarea['enabled'] >
	>
	type $mol_textarea__value_bog_vmap_app_code_27 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_code['css_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__event_bog_vmap_app_code_28 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_vmap_app_code['css_press'] > ): ReturnType< $bog_vmap_app_code['css_press'] >,
		})  & ReturnType< $mol_textarea['event'] >
		,
		ReturnType< $mol_textarea['event'] >
	>
	export class $bog_vmap_app_code extends $mol_page {
		field_leave( next?: any ): any
		scope_note( ): string
		Scope( ): $mol_check
		note( ): string
		typing_rows( ): readonly($mol_view)[]
		typing_text( id: any): string
		source_tabs( ): readonly($mol_view)[]
		tree_text( next?: string ): string
		tree_press( next?: any ): any
		js_text( next?: string ): string
		js_press( next?: any ): any
		js_idle_note( ): string
		css_text( next?: string ): string
		css_press( next?: any ): any
		klass( ): string
		prop( ): string
		hooks( ): readonly(string)[]
		source( next?: string ): string
		node_source( next?: string ): string
		js( next?: string ): string
		css( next?: string ): string
		error( ): string
		node_note( ): string
		whole( next?: boolean ): boolean
		refusal( next?: string ): string
		field_undo( ): boolean
		editable( ): boolean
		event( ): ({ 
			focusout( next?: ReturnType< $bog_vmap_app_code['field_leave'] > ): ReturnType< $bog_vmap_app_code['field_leave'] >,
		})  & ReturnType< $mol_page['event'] >
		title( ): ReturnType< $bog_vmap_app_code['scope_note'] >
		tools( ): readonly(any)[]
		Alarm( ): $mol_status
		Refusal( ): $mol_status
		Typing( ): $mol_list
		Typing_row( id: any): $mol_status
		Sources( ): $bog_vmap_app_code_deck
		Tree( ): $mol_textarea
		Js( ): $mol_textarea
		Js_idle( ): $mol_status
		Css( ): $mol_textarea
	}
	
	export class $bog_vmap_app_code_deck extends $mol_deck {
	}
	
}

//# sourceMappingURL=code.view.tree.d.ts.map